var _style, _path, _path2, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/2000/svg",
    type: "text/css"
  }, "\n\t.st0{fill:#2993F7;}\n\t.st1{fill:#0E538D;}\n\t.st2{opacity:0.25;fill:#D1D1D1;}\n\t.st3{fill:#E9E9E9;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#E99D1B;}\n\t.st6{fill:#FFDB80;}\n\t.st7{fill:#ffbf66;}\n\t.st8{opacity:0.7;fill:#FFFFFF;}\n\t.st9{opacity:0.5;fill:#FFFFFF;}\n\t.st10{opacity:0.45;fill:#E99D1B;}\n\t.st11{fill:#F9D987;}\n\t.st12{fill:#D3D3D3;}\n\t.st13{fill:#AFAFAF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    d: "M651.9,146.8l-46.4-80.3c-3.7-6.3-12.8-6.3-16.4,0l-46.9,81.2l-46.9,81.2c-3.7,6.3,0.9,14.2,8.2,14.2l31.4,0  c5.2,0,9.5,4.3,9.5,9.5V521c0,5.2,4.3,9.5,9.5,9.5h32.8C578.9,302.5,617.6,196.1,651.9,146.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st1",
    d: "M652.4,147.7l-0.5-0.8c-34.4,49.3-73.1,155.7-65.2,383.6h54c5.2,0,9.5-4.3,9.5-9.5V252.6c0-5.2,4.3-9.5,9.5-9.5  h31.4c7.3,0,11.9-7.9,8.2-14.2L652.4,147.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 391.9,
    cy: 621.7,
    rx: 282.5,
    ry: 40.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "135.5,512.2 133.5,512.2 133.5,198.7 421,198.7 421,200.7 135.5,200.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 482.2,
    className: "st3",
    width: 136.1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 446.8,
    className: "st3",
    width: 173.5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 411.3,
    className: "st3",
    width: 183.1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 375.9,
    className: "st3",
    width: 221.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 340.4,
    className: "st3",
    width: 234.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 305,
    className: "st3",
    width: 223.5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 269.5,
    className: "st3",
    width: 233.5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 234.1,
    className: "st3",
    width: 283.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 199.7,
    className: "st3",
    width: 2,
    height: 54.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.5,
    y: 199.7,
    className: "st3",
    width: 2,
    height: 199.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 199.7,
    className: "st3",
    width: 2,
    height: 270
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.5,
    y: 199.7,
    className: "st3",
    width: 2,
    height: 312
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 199.7,
    className: "st3",
    width: 2,
    height: 312
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 233.5,
    cy: 306,
    r: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.5,313.6c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6c4.2,0,7.6,3.4,7.6,7.6    C241,310.2,237.7,313.6,233.5,313.6z M233.5,302.4c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6    C237,304,235.4,302.4,233.5,302.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288.5,340.3c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6    C286.1,334.7,288.5,337.2,288.5,340.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283,347.8c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6c4.2,0,7.6,3.4,7.6,7.6    C290.5,344.4,287.2,347.8,283,347.8z M283,336.7c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6    C286.5,338.3,285,336.7,283,336.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 253.3,
    y: 283.7,
    transform: "matrix(0.4206 -0.9072 0.9072 0.4206 -80.1525 445.8712)",
    className: "st0",
    width: 111.5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.7,
    y: 299.5,
    transform: "matrix(0.5756 -0.8177 0.8177 0.5756 -155.6104 348.2442)",
    className: "st0",
    width: 4,
    height: 49.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.9,
    y: 342,
    transform: "matrix(0.5778 -0.8162 0.8162 0.5778 -193.2375 314.43)",
    className: "st0",
    width: 80.7,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.5,375.9c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6    C187.1,370.3,189.5,372.8,189.5,375.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,383.4c-4.2,0-7.6-3.4-7.6-7.6s3.4-7.6,7.6-7.6s7.6,3.4,7.6,7.6S188.2,383.4,184,383.4z M184,372.3    c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6C187.5,373.9,185.9,372.3,184,372.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,234.3c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6    C335.6,228.7,338.1,231.2,338.1,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.5,241.8c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6s7.6,3.4,7.6,7.6    C340.1,238.4,336.7,241.8,332.5,241.8z M332.5,230.7c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6    C336.1,232.3,334.5,230.7,332.5,230.7z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173,553.9c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291.8,551.4V551v-14.4c0-2.5-2.1-4.6-4.6-4.6H176.9c-2.5,0-4.6,2.1-4.6,4.6V551v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C291.5,553.2,291.8,552.3,291.8,551.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176.2,552.2L176.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C177.1,551.8,176.7,552.2,176.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M180.9,552.2L180.9,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C181.8,551.8,181.4,552.2,180.9,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.5,552.2L185.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C186.5,551.8,186,552.2,185.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.2,552.2L190.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C191.1,551.8,190.7,552.2,190.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.9,552.2L194.9,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C195.8,551.8,195.4,552.2,194.9,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.5,552.2L199.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C200.5,551.8,200,552.2,199.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M204.2,552.2L204.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C205.1,551.8,204.7,552.2,204.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.8,552.2L208.8,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C209.8,551.8,209.4,552.2,208.8,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M213.5,552.2L213.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C214.4,551.8,214,552.2,213.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M218.2,552.2L218.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C219.1,551.8,218.7,552.2,218.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M222.8,552.2L222.8,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C223.8,551.8,223.4,552.2,222.8,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M227.5,552.2L227.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C228.4,551.8,228,552.2,227.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M232.2,552.2L232.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C233.1,551.8,232.7,552.2,232.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M236.8,552.2L236.8,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C237.8,551.8,237.4,552.2,236.8,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.5,552.2L241.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C242.4,551.8,242,552.2,241.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M246.2,552.2L246.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C247.1,551.8,246.7,552.2,246.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.8,552.2L250.8,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C251.8,551.8,251.4,552.2,250.8,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.5,552.2L255.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C256.4,551.8,256,552.2,255.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.2,552.2L260.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C261.1,551.8,260.7,552.2,260.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M264.8,552.2L264.8,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C265.8,551.8,265.3,552.2,264.8,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M269.5,552.2L269.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C270.4,551.8,270,552.2,269.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M274.2,552.2L274.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C275.1,551.8,274.7,552.2,274.2,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M278.8,552.2L278.8,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C279.8,551.8,279.3,552.2,278.8,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M283.5,552.2L283.5,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C284.4,551.8,284,552.2,283.5,552.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M288.2,552.2L288.2,552.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C289.1,551.8,288.7,552.2,288.2,552.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.9,
    y: 531.9,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.9,
    y: 553.9,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 243.8,
    y: 531.9,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.6,602c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.3,599.5V599v-14.4c0-2.5-2.1-4.6-4.6-4.6H174.4c-2.5,0-4.6,2.1-4.6,4.6V599v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C289,601.3,289.3,600.4,289.3,599.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.7,600.3L173.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C174.6,599.8,174.2,600.3,173.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178.4,600.3L178.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C179.3,599.8,178.9,600.3,178.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183,600.3L183,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C184,599.8,183.6,600.3,183,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M187.7,600.3L187.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C188.6,599.8,188.2,600.3,187.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192.4,600.3L192.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C193.3,599.8,192.9,600.3,192.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197,600.3L197,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C198,599.8,197.6,600.3,197,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.7,600.3L201.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C202.6,599.8,202.2,600.3,201.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.4,600.3L206.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C207.3,599.8,206.9,600.3,206.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211,600.3L211,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C212,599.8,211.5,600.3,211,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.7,600.3L215.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C216.6,599.8,216.2,600.3,215.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.4,600.3L220.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C221.3,599.8,220.9,600.3,220.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225,600.3L225,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C226,599.8,225.5,600.3,225,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M229.7,600.3L229.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C230.6,599.8,230.2,600.3,229.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.4,600.3L234.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C235.3,599.8,234.9,600.3,234.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239,600.3L239,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C240,599.8,239.5,600.3,239,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243.7,600.3L243.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C244.6,599.8,244.2,600.3,243.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.4,600.3L248.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C249.3,599.8,248.9,600.3,248.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M253,600.3L253,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C254,599.8,253.5,600.3,253,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M257.7,600.3L257.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C258.6,599.8,258.2,600.3,257.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262.4,600.3L262.4,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C263.3,599.8,262.9,600.3,262.4,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M267,600.3L267,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C267.9,599.8,267.5,600.3,267,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.7,600.3L271.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C272.6,599.8,272.2,600.3,271.7,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276.3,600.3L276.3,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C277.3,599.8,276.9,600.3,276.3,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M281,600.3L281,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281.9,599.8,281.5,600.3,281,600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.7,600.3L285.7,600.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C286.6,599.8,286.2,600.3,285.7,600.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 580,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 602,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.3,
    y: 580,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.8,626c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.6,623.5V623v-14.4c0-2.5-2.1-4.6-4.6-4.6H159.7c-2.5,0-4.6,2.1-4.6,4.6V623v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C274.3,625.2,274.6,624.4,274.6,623.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M159,624.2L159,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C159.9,623.8,159.5,624.2,159,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M163.6,624.2L163.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C164.6,623.8,164.1,624.2,163.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M168.3,624.2L168.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C169.2,623.8,168.8,624.2,168.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173,624.2L173,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C173.9,623.8,173.5,624.2,173,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M177.6,624.2L177.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C178.6,623.8,178.1,624.2,177.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M182.3,624.2L182.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C183.2,623.8,182.8,624.2,182.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M187,624.2L187,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C187.9,623.8,187.5,624.2,187,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M191.6,624.2L191.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C192.6,623.8,192.1,624.2,191.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M196.3,624.2L196.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C197.2,623.8,196.8,624.2,196.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201,624.2L201,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C201.9,623.8,201.5,624.2,201,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M205.6,624.2L205.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C206.6,623.8,206.1,624.2,205.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M210.3,624.2L210.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C211.2,623.8,210.8,624.2,210.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.9,624.2L214.9,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C215.9,623.8,215.5,624.2,214.9,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M219.6,624.2L219.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C220.5,623.8,220.1,624.2,219.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M224.3,624.2L224.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C225.2,623.8,224.8,624.2,224.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M228.9,624.2L228.9,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C229.9,623.8,229.5,624.2,228.9,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234,624.2h-0.7c-0.3,0-0.6-0.3-0.6-0.6v-17.5c0-0.3,0.3-0.6,0.6-0.6h0.7c0.3,0,0.6,0.3,0.6,0.6v17.5        C234.5,624,234.3,624.2,234,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.3,624.2L238.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C239.2,623.8,238.8,624.2,238.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M242.9,624.2L242.9,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C243.9,623.8,243.5,624.2,242.9,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M247.6,624.2L247.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C248.5,623.8,248.1,624.2,247.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.3,624.2L252.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C253.2,623.8,252.8,624.2,252.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256.9,624.2L256.9,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C257.9,623.8,257.4,624.2,256.9,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,624.2L261.6,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C262.5,623.8,262.1,624.2,261.6,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266.3,624.2L266.3,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C267.2,623.8,266.8,624.2,266.3,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M270.9,624.2L270.9,624.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C271.9,623.8,271.4,624.2,270.9,624.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.7,
    y: 604,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.7,
    y: 626,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 604,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M166.2,577.9c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285,575.4v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H170.1c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C284.7,577.2,285,576.3,285,575.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.4,576.2L169.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C170.3,575.7,169.9,576.2,169.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174,576.2L174,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C175,575.7,174.6,576.2,174,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178.7,576.2L178.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C179.6,575.7,179.2,576.2,178.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183.4,576.2L183.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C184.3,575.7,183.9,576.2,183.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M188,576.2L188,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C189,575.7,188.6,576.2,188,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192.7,576.2L192.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C193.6,575.7,193.2,576.2,192.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197.4,576.2L197.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C198.3,575.7,197.9,576.2,197.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202,576.2L202,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C203,575.7,202.5,576.2,202,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.7,576.2L206.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C207.6,575.7,207.2,576.2,206.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211.4,576.2L211.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C212.3,575.7,211.9,576.2,211.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M216,576.2L216,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C217,575.7,216.5,576.2,216,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.7,576.2L220.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C221.6,575.7,221.2,576.2,220.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.4,576.2L225.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C226.3,575.7,225.9,576.2,225.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M230,576.2L230,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C231,575.7,230.5,576.2,230,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.7,576.2L234.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C235.6,575.7,235.2,576.2,234.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.4,576.2L239.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C240.3,575.7,239.9,576.2,239.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M244,576.2L244,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C245,575.7,244.5,576.2,244,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.7,576.2L248.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C249.6,575.7,249.2,576.2,248.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M253.4,576.2L253.4,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C254.3,575.7,253.9,576.2,253.4,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M258,576.2L258,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C258.9,575.7,258.5,576.2,258,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262.7,576.2L262.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C263.6,575.7,263.2,576.2,262.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M267.3,576.2L267.3,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C268.3,575.7,267.9,576.2,267.3,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272,576.2L272,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C272.9,575.7,272.5,576.2,272,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276.7,576.2L276.7,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C277.6,575.7,277.2,576.2,276.7,576.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M281.3,576.2L281.3,576.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C282.3,575.7,281.9,576.2,281.3,576.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 555.9,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 577.9,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 555.9,
    className: "st10",
    width: 41.9,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.2,449.1c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H334.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452.9,446.6v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H338.1c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C452.7,448.3,452.9,447.5,452.9,446.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.3,447.3L337.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C338.3,446.9,337.9,447.3,337.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M342,447.3L342,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C342.9,446.9,342.5,447.3,342,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.7,447.3L346.7,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C347.6,446.9,347.2,447.3,346.7,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M351.3,447.3L351.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C352.3,446.9,351.8,447.3,351.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M356,447.3L356,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356.9,446.9,356.5,447.3,356,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M360.7,447.3L360.7,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C361.6,446.9,361.2,447.3,360.7,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M365.3,447.3L365.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C366.3,446.9,365.8,447.3,365.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M370,447.3L370,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370.9,446.9,370.5,447.3,370,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M374.7,447.3L374.7,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C375.6,446.9,375.2,447.3,374.7,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M379.3,447.3L379.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C380.3,446.9,379.8,447.3,379.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M384,447.3L384,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384.9,446.9,384.5,447.3,384,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M388.7,447.3L388.7,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C389.6,446.9,389.2,447.3,388.7,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.3,447.3L393.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C394.3,446.9,393.8,447.3,393.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M398,447.3L398,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C398.9,446.9,398.5,447.3,398,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.7,447.3L402.7,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C403.6,446.9,403.2,447.3,402.7,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M407.3,447.3L407.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C408.3,446.9,407.8,447.3,407.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M412,447.3L412,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412.9,446.9,412.5,447.3,412,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M416.6,447.3L416.6,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C417.6,446.9,417.2,447.3,416.6,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M421.3,447.3L421.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C422.2,446.9,421.8,447.3,421.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M426,447.3L426,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426.9,446.9,426.5,447.3,426,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M430.6,447.3L430.6,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C431.6,446.9,431.2,447.3,430.6,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M435.3,447.3L435.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C436.2,446.9,435.8,447.3,435.3,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M440,447.3L440,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440.9,446.9,440.5,447.3,440,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M444.6,447.3L444.6,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C445.6,446.9,445.2,447.3,444.6,447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M449.3,447.3L449.3,447.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C450.2,446.9,449.8,447.3,449.3,447.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 427.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 449.1,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 404.9,
    y: 427.1,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.7,497.1c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M461.4,494.6v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H346.6c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C461.2,496.4,461.4,495.6,461.4,494.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.9,495.4L345.9,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.8,495,346.4,495.4,345.9,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.5,495.4L350.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.5,495,351,495.4,350.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.2,495.4L355.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356.1,495,355.7,495.4,355.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.9,495.4L359.9,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.8,495,360.4,495.4,359.9,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.5,495.4L364.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365.5,495,365,495.4,364.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.2,495.4L369.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370.1,495,369.7,495.4,369.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.8,495.4L373.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C374.8,495,374.4,495.4,373.8,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.5,495.4L378.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C379.4,495,379,495.4,378.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.2,495.4L383.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384.1,495,383.7,495.4,383.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M387.8,495.4L387.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C388.8,495,388.4,495.4,387.8,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.5,495.4L392.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C393.4,495,393,495.4,392.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M397.2,495.4L397.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C398.1,495,397.7,495.4,397.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M401.8,495.4L401.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C402.8,495,402.4,495.4,401.8,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.5,495.4L406.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C407.4,495,407,495.4,406.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.2,495.4L411.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412.1,495,411.7,495.4,411.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.8,495.4L415.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C416.8,495,416.3,495.4,415.8,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M420.5,495.4L420.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C421.4,495,421,495.4,420.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M425.2,495.4L425.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426.1,495,425.7,495.4,425.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M429.8,495.4L429.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C430.8,495,430.3,495.4,429.8,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M434.5,495.4L434.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C435.4,495,435,495.4,434.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M439.2,495.4L439.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440.1,495,439.7,495.4,439.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M443.8,495.4L443.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C444.8,495,444.3,495.4,443.8,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M448.5,495.4L448.5,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C449.4,495,449,495.4,448.5,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.2,495.4L453.2,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C454.1,495,453.7,495.4,453.2,495.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M457.8,495.4L457.8,495.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C458.8,495,458.3,495.4,457.8,495.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.6,
    y: 475.2,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.6,
    y: 497.1,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 413.5,
    y: 475.2,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M345,521.1c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M463.7,518.6v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H348.8c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C463.4,520.4,463.7,519.5,463.7,518.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348.1,519.4L348.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C349,518.9,348.6,519.4,348.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M352.8,519.4L352.8,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C353.7,518.9,353.3,519.4,352.8,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M357.4,519.4L357.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C358.4,518.9,358,519.4,357.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M362.1,519.4L362.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C363,518.9,362.6,519.4,362.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M366.8,519.4L366.8,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C367.7,518.9,367.3,519.4,366.8,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M371.4,519.4L371.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C372.4,518.9,371.9,519.4,371.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M376.1,519.4L376.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C377,518.9,376.6,519.4,376.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.8,519.4L380.8,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C381.7,518.9,381.3,519.4,380.8,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M385.4,519.4L385.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C386.4,518.9,385.9,519.4,385.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M390.1,519.4L390.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C391,518.9,390.6,519.4,390.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M394.8,519.4L394.8,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C395.7,518.9,395.3,519.4,394.8,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M399.4,519.4L399.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C400.4,518.9,399.9,519.4,399.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M404.1,519.4L404.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C405,518.9,404.6,519.4,404.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M408.8,519.4L408.8,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C409.7,518.9,409.3,519.4,408.8,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M413.4,519.4L413.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C414.4,518.9,413.9,519.4,413.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M418.1,519.4L418.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C419,518.9,418.6,519.4,418.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M423.1,519.4h-0.7c-0.3,0-0.6-0.3-0.6-0.6v-17.5c0-0.3,0.3-0.6,0.6-0.6h0.7c0.3,0,0.6,0.3,0.6,0.6v17.5        C423.7,519.1,423.4,519.4,423.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M427.4,519.4L427.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C428.4,518.9,427.9,519.4,427.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M432.1,519.4L432.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C433,518.9,432.6,519.4,432.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M436.8,519.4L436.8,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C437.7,518.9,437.3,519.4,436.8,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.4,519.4L441.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C442.3,518.9,441.9,519.4,441.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M446.1,519.4L446.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C447,518.9,446.6,519.4,446.1,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M450.7,519.4L450.7,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C451.7,518.9,451.3,519.4,450.7,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M455.4,519.4L455.4,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C456.3,518.9,455.9,519.4,455.4,519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M460.1,519.4L460.1,519.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C461,518.9,460.6,519.4,460.1,519.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 499.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 521.1,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 415.7,
    y: 499.1,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M347.4,473c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H347.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M466.1,470.5v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H351.2c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C465.8,472.3,466.1,471.5,466.1,470.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.5,471.3L350.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.5,470.9,351,471.3,350.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.2,471.3L355.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356.1,470.9,355.7,471.3,355.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.9,471.3L359.9,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.8,470.9,360.4,471.3,359.9,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.5,471.3L364.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365.5,470.9,365,471.3,364.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.2,471.3L369.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370.1,470.9,369.7,471.3,369.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.8,471.3L373.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C374.8,470.9,374.4,471.3,373.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.5,471.3L378.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C379.4,470.9,379,471.3,378.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.2,471.3L383.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384.1,470.9,383.7,471.3,383.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M387.8,471.3L387.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C388.8,470.9,388.4,471.3,387.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.5,471.3L392.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C393.4,470.9,393,471.3,392.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M397.2,471.3L397.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C398.1,470.9,397.7,471.3,397.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M401.8,471.3L401.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C402.8,470.9,402.4,471.3,401.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.5,471.3L406.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C407.4,470.9,407,471.3,406.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.2,471.3L411.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412.1,470.9,411.7,471.3,411.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.8,471.3L415.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C416.8,470.9,416.3,471.3,415.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M420.5,471.3L420.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C421.4,470.9,421,471.3,420.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M425.2,471.3L425.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426.1,470.9,425.7,471.3,425.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M429.8,471.3L429.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C430.8,470.9,430.3,471.3,429.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M434.5,471.3L434.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C435.4,470.9,435,471.3,434.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M439.2,471.3L439.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440.1,470.9,439.7,471.3,439.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M443.8,471.3L443.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C444.8,470.9,444.3,471.3,443.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M448.5,471.3L448.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C449.4,470.9,449,471.3,448.5,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.2,471.3L453.2,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C454.1,470.9,453.7,471.3,453.2,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M457.8,471.3L457.8,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C458.8,470.9,458.3,471.3,457.8,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M462.5,471.3L462.5,471.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C463.4,470.9,463,471.3,462.5,471.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 451.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 473,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 418.1,
    y: 451.1,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.9,424.9c0.8,1.3,2.3,2.1,3.9,2.1H457c1.6,0,3-0.9,3.9-2.1H342.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M461.6,422.4V422v-14.4c0-2.5-2.1-4.6-4.6-4.6H346.7c-2.5,0-4.6,2.1-4.6,4.6V422v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C461.3,424.2,461.6,423.3,461.6,422.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346,423.2L346,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.9,422.8,346.5,423.2,346,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.7,423.2L350.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.6,422.8,351.2,423.2,350.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.3,423.2L355.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356.3,422.8,355.9,423.2,355.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M360,423.2L360,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.9,422.8,360.5,423.2,360,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.7,423.2L364.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365.6,422.8,365.2,423.2,364.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.3,423.2L369.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370.3,422.8,369.8,423.2,369.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M374,423.2L374,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C374.9,422.8,374.5,423.2,374,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.7,423.2L378.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C379.6,422.8,379.2,423.2,378.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.3,423.2L383.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384.3,422.8,383.8,423.2,383.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M388,423.2L388,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C388.9,422.8,388.5,423.2,388,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.7,423.2L392.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C393.6,422.8,393.2,423.2,392.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M397.3,423.2L397.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C398.3,422.8,397.8,423.2,397.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402,423.2L402,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C402.9,422.8,402.5,423.2,402,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.7,423.2L406.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C407.6,422.8,407.2,423.2,406.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.3,423.2L411.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412.3,422.8,411.8,423.2,411.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M416,423.2L416,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C416.9,422.8,416.5,423.2,416,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M420.7,423.2L420.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C421.6,422.8,421.2,423.2,420.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M425.3,423.2L425.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426.3,422.8,425.8,423.2,425.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M430,423.2L430,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C430.9,422.8,430.5,423.2,430,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M434.7,423.2L434.7,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C435.6,422.8,435.2,423.2,434.7,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M439.3,423.2L439.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440.2,422.8,439.8,423.2,439.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M444,423.2L444,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C444.9,422.8,444.5,423.2,444,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M448.6,423.2L448.6,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C449.6,422.8,449.2,423.2,448.6,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.3,423.2L453.3,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C454.2,422.8,453.8,423.2,453.3,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M458,423.2L458,423.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C458.9,422.8,458.5,423.2,458,423.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.7,
    y: 402.9,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.7,
    y: 424.9,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 413.6,
    y: 402.9,
    className: "st10",
    width: 41.9,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259.4,518c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M378.1,515.5V515v-14.4c0-2.5-2.1-4.6-4.6-4.6H263.3c-2.5,0-4.6,2.1-4.6,4.6V515v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C377.9,517.2,378.1,516.4,378.1,515.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262.5,516.2L262.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C263.5,515.8,263.1,516.2,262.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M267.2,516.2L267.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C268.1,515.8,267.7,516.2,267.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.9,516.2L271.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C272.8,515.8,272.4,516.2,271.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276.5,516.2L276.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C277.5,515.8,277.1,516.2,276.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M281.2,516.2L281.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C282.1,515.8,281.7,516.2,281.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.9,516.2L285.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C286.8,515.8,286.4,516.2,285.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.5,516.2L290.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C291.5,515.8,291.1,516.2,290.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M295.2,516.2L295.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C296.1,515.8,295.7,516.2,295.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.9,516.2L299.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C300.8,515.8,300.4,516.2,299.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.5,516.2L304.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C305.5,515.8,305,516.2,304.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M309.2,516.2L309.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C310.1,515.8,309.7,516.2,309.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.9,516.2L313.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C314.8,515.8,314.4,516.2,313.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.5,516.2L318.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C319.5,515.8,319,516.2,318.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M323.2,516.2L323.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C324.1,515.8,323.7,516.2,323.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.9,516.2L327.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C328.8,515.8,328.4,516.2,327.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.5,516.2L332.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C333.5,515.8,333,516.2,332.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.2,516.2L337.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C338.1,515.8,337.7,516.2,337.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M341.9,516.2L341.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C342.8,515.8,342.4,516.2,341.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.5,516.2L346.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C347.5,515.8,347,516.2,346.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M351.2,516.2L351.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C352.1,515.8,351.7,516.2,351.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.9,516.2L355.9,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356.8,515.8,356.4,516.2,355.9,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M360.5,516.2L360.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C361.5,515.8,361,516.2,360.5,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M365.2,516.2L365.2,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C366.1,515.8,365.7,516.2,365.2,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.8,516.2L369.8,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370.8,515.8,370.4,516.2,369.8,516.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M374.5,516.2L374.5,516.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C375.4,515.8,375,516.2,374.5,516.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.3,
    y: 496,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.3,
    y: 518,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 330.1,
    y: 496,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M267.9,566c0.8,1.3,2.3,2.1,3.9,2.1H382c1.6,0,3-0.9,3.9-2.1H267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M386.7,563.5v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H271.8c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C386.4,565.3,386.7,564.4,386.7,563.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.1,564.3L271.1,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C272,563.9,271.6,564.3,271.1,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.7,564.3L275.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C276.7,563.9,276.2,564.3,275.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M280.4,564.3L280.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281.3,563.9,280.9,564.3,280.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.1,564.3L285.1,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C286,563.9,285.6,564.3,285.1,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M289.7,564.3L289.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C290.7,563.9,290.2,564.3,289.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.4,564.3L294.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C295.3,563.9,294.9,564.3,294.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.1,564.3L299.1,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C300,563.9,299.6,564.3,299.1,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.7,564.3L303.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C304.7,563.9,304.2,564.3,303.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308.4,564.3L308.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C309.3,563.9,308.9,564.3,308.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.1,564.3L313.1,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C314,563.9,313.6,564.3,313.1,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.7,564.3L317.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C318.7,563.9,318.2,564.3,317.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.4,564.3L322.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C323.3,563.9,322.9,564.3,322.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327,564.3L327,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C328,563.9,327.6,564.3,327,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.7,564.3L331.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C332.6,563.9,332.2,564.3,331.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336.4,564.3L336.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C337.3,563.9,336.9,564.3,336.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M341,564.3L341,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C342,563.9,341.6,564.3,341,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.7,564.3L345.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.6,563.9,346.2,564.3,345.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.4,564.3L350.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.3,563.9,350.9,564.3,350.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355,564.3L355,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356,563.9,355.6,564.3,355,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.7,564.3L359.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.6,563.9,360.2,564.3,359.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.4,564.3L364.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365.3,563.9,364.9,564.3,364.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369,564.3L369,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370,563.9,369.5,564.3,369,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.7,564.3L373.7,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C374.6,563.9,374.2,564.3,373.7,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.4,564.3L378.4,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C379.3,563.9,378.9,564.3,378.4,564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383,564.3L383,564.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384,563.9,383.5,564.3,383,564.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 282.8,
    y: 544.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.8,
    y: 566,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 338.7,
    y: 544.1,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M270.2,590c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M388.9,587.5V587v-14.4c0-2.5-2.1-4.6-4.6-4.6H274c-2.5,0-4.6,2.1-4.6,4.6V587v0.5c0,0.9,0.3,1.8,0.7,2.5        h118C388.6,589.3,388.9,588.4,388.9,587.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M273.3,588.3L273.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C274.3,587.8,273.8,588.3,273.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M278,588.3L278,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C278.9,587.8,278.5,588.3,278,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M282.6,588.3L282.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C283.6,587.8,283.2,588.3,282.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287.3,588.3L287.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C288.2,587.8,287.8,588.3,287.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M292,588.3L292,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C292.9,587.8,292.5,588.3,292,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M296.6,588.3L296.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C297.6,587.8,297.2,588.3,296.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M301.3,588.3L301.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C302.2,587.8,301.8,588.3,301.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M306,588.3L306,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C306.9,587.8,306.5,588.3,306,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M310.6,588.3L310.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C311.6,587.8,311.2,588.3,310.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M315.3,588.3L315.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C316.2,587.8,315.8,588.3,315.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M320,588.3L320,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C320.9,587.8,320.5,588.3,320,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M324.6,588.3L324.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C325.6,587.8,325.1,588.3,324.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M329.3,588.3L329.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C330.2,587.8,329.8,588.3,329.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M334,588.3L334,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C334.9,587.8,334.5,588.3,334,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.6,588.3L338.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C339.6,587.8,339.1,588.3,338.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M343.3,588.3L343.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C344.2,587.8,343.8,588.3,343.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348.3,588.3h-0.7c-0.3,0-0.6-0.3-0.6-0.6v-17.5c0-0.3,0.3-0.6,0.6-0.6h0.7c0.3,0,0.6,0.3,0.6,0.6v17.5        C348.9,588,348.6,588.3,348.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M352.6,588.3L352.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C353.6,587.8,353.1,588.3,352.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M357.3,588.3L357.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C358.2,587.8,357.8,588.3,357.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M362,588.3L362,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C362.9,587.8,362.5,588.3,362,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M366.6,588.3L366.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C367.6,587.8,367.1,588.3,366.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M371.3,588.3L371.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C372.2,587.8,371.8,588.3,371.3,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M376,588.3L376,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C376.9,587.8,376.5,588.3,376,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.6,588.3L380.6,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C381.6,587.8,381.1,588.3,380.6,588.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M385.3,588.3L385.3,588.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C386.2,587.8,385.8,588.3,385.3,588.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 568,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 590,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 340.9,
    y: 568,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.6,541.9c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M391.3,539.4V539v-14.4c0-2.5-2.1-4.6-4.6-4.6H276.5c-2.5,0-4.6,2.1-4.6,4.6V539v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C391,541.2,391.3,540.4,391.3,539.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.7,540.2L275.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C276.7,539.8,276.2,540.2,275.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M280.4,540.2L280.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281.3,539.8,280.9,540.2,280.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.1,540.2L285.1,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C286,539.8,285.6,540.2,285.1,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M289.7,540.2L289.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C290.7,539.8,290.2,540.2,289.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.4,540.2L294.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C295.3,539.8,294.9,540.2,294.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.1,540.2L299.1,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C300,539.8,299.6,540.2,299.1,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.7,540.2L303.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C304.7,539.8,304.2,540.2,303.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308.4,540.2L308.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C309.3,539.8,308.9,540.2,308.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.1,540.2L313.1,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C314,539.8,313.6,540.2,313.1,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.7,540.2L317.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C318.7,539.8,318.2,540.2,317.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.4,540.2L322.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C323.3,539.8,322.9,540.2,322.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327,540.2L327,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C328,539.8,327.6,540.2,327,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.7,540.2L331.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C332.6,539.8,332.2,540.2,331.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336.4,540.2L336.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C337.3,539.8,336.9,540.2,336.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M341,540.2L341,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C342,539.8,341.6,540.2,341,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.7,540.2L345.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.6,539.8,346.2,540.2,345.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.4,540.2L350.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.3,539.8,350.9,540.2,350.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355,540.2L355,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356,539.8,355.6,540.2,355,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.7,540.2L359.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.6,539.8,360.2,540.2,359.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.4,540.2L364.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365.3,539.8,364.9,540.2,364.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369,540.2L369,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370,539.8,369.5,540.2,369,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.7,540.2L373.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C374.6,539.8,374.2,540.2,373.7,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.4,540.2L378.4,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C379.3,539.8,378.9,540.2,378.4,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383,540.2L383,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384,539.8,383.5,540.2,383,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M387.7,540.2L387.7,540.2c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C388.6,539.8,388.2,540.2,387.7,540.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.4,
    y: 520,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.4,
    y: 541.9,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 343.3,
    y: 520,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.1,493.8c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H268.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M386.8,491.3v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H271.9c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C386.5,493.1,386.8,492.2,386.8,491.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.2,492.1L271.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C272.2,491.7,271.7,492.1,271.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.9,492.1L275.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C276.8,491.7,276.4,492.1,275.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M280.5,492.1L280.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281.5,491.7,281.1,492.1,280.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.2,492.1L285.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C286.1,491.7,285.7,492.1,285.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M289.9,492.1L289.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C290.8,491.7,290.4,492.1,289.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.5,492.1L294.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C295.5,491.7,295.1,492.1,294.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.2,492.1L299.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C300.1,491.7,299.7,492.1,299.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.9,492.1L303.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C304.8,491.7,304.4,492.1,303.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308.5,492.1L308.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C309.5,491.7,309.1,492.1,308.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.2,492.1L313.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C314.1,491.7,313.7,492.1,313.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.9,492.1L317.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C318.8,491.7,318.4,492.1,317.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.5,492.1L322.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C323.5,491.7,323,492.1,322.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.2,492.1L327.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C328.1,491.7,327.7,492.1,327.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.9,492.1L331.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C332.8,491.7,332.4,492.1,331.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336.5,492.1L336.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C337.5,491.7,337,492.1,336.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M341.2,492.1L341.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C342.1,491.7,341.7,492.1,341.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.9,492.1L345.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.8,491.7,346.4,492.1,345.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.5,492.1L350.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.5,491.7,351,492.1,350.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.2,492.1L355.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C356.1,491.7,355.7,492.1,355.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.9,492.1L359.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.8,491.7,360.4,492.1,359.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.5,492.1L364.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365.5,491.7,365,492.1,364.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.2,492.1L369.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C370.1,491.7,369.7,492.1,369.2,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.9,492.1L373.9,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C374.8,491.7,374.4,492.1,373.9,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M378.5,492.1L378.5,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C379.5,491.7,379,492.1,378.5,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.2,492.1L383.2,492.1c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C384.1,491.7,383.7,492.1,383.2,492.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 282.9,
    y: 471.8,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.9,
    y: 493.8,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 338.8,
    y: 471.8,
    className: "st10",
    width: 41.9,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M385.4,541.6c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H385.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.1,539.1v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H389.3c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C503.9,540.8,504.1,540,504.1,539.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M388.6,539.8L388.6,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C389.5,539.4,389.1,539.8,388.6,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.2,539.8L393.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C394.2,539.4,393.7,539.8,393.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M397.9,539.8L397.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C398.8,539.4,398.4,539.8,397.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.5,539.8L402.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C403.5,539.4,403.1,539.8,402.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M407.2,539.8L407.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C408.1,539.4,407.7,539.8,407.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.9,539.8L411.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412.8,539.4,412.4,539.8,411.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M416.5,539.8L416.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C417.5,539.4,417.1,539.8,416.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M421.2,539.8L421.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C422.1,539.4,421.7,539.8,421.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M425.9,539.8L425.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426.8,539.4,426.4,539.8,425.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M430.5,539.8L430.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C431.5,539.4,431.1,539.8,430.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M435.2,539.8L435.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C436.1,539.4,435.7,539.8,435.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M439.9,539.8L439.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440.8,539.4,440.4,539.8,439.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M444.5,539.8L444.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C445.5,539.4,445.1,539.8,444.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M449.2,539.8L449.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C450.1,539.4,449.7,539.8,449.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.9,539.8L453.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C454.8,539.4,454.4,539.8,453.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M458.5,539.8L458.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C459.5,539.4,459,539.8,458.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M463.2,539.8L463.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C464.1,539.4,463.7,539.8,463.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.9,539.8L467.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C468.8,539.4,468.4,539.8,467.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M472.5,539.8L472.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C473.5,539.4,473,539.8,472.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M477.2,539.8L477.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C478.1,539.4,477.7,539.8,477.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M481.9,539.8L481.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C482.8,539.4,482.4,539.8,481.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M486.5,539.8L486.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C487.5,539.4,487,539.8,486.5,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M491.2,539.8L491.2,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C492.1,539.4,491.7,539.8,491.2,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M495.9,539.8L495.9,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C496.8,539.4,496.4,539.8,495.9,539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M500.5,539.8L500.5,539.8c-0.5,0-0.9-0.4-0.9-0.9V522c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C501.5,539.4,501,539.8,500.5,539.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.3,
    y: 519.6,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.3,
    y: 541.6,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 456.1,
    y: 519.6,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M393.9,589.6c0.8,1.3,2.3,2.1,3.9,2.1H508c1.6,0,3-0.9,3.9-2.1H393.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M512.7,587.1v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H397.8c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C512.4,588.9,512.7,588,512.7,587.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M397.1,587.9L397.1,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C398,587.5,397.6,587.9,397.1,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M401.7,587.9L401.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C402.7,587.5,402.2,587.9,401.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.4,587.9L406.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C407.3,587.5,406.9,587.9,406.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.1,587.9L411.1,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C412,587.5,411.6,587.9,411.1,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.7,587.9L415.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C416.7,587.5,416.2,587.9,415.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M420.4,587.9L420.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C421.3,587.5,420.9,587.9,420.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M425.1,587.9L425.1,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C426,587.5,425.6,587.9,425.1,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M429.7,587.9L429.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C430.7,587.5,430.2,587.9,429.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M434.4,587.9L434.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C435.3,587.5,434.9,587.9,434.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M439.1,587.9L439.1,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C440,587.5,439.6,587.9,439.1,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M443.7,587.9L443.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C444.7,587.5,444.2,587.9,443.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M448.4,587.9L448.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C449.3,587.5,448.9,587.9,448.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.1,587.9L453.1,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C454,587.5,453.6,587.9,453.1,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M457.7,587.9L457.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C458.7,587.5,458.2,587.9,457.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M462.4,587.9L462.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C463.3,587.5,462.9,587.9,462.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.1,587.9L467.1,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C468,587.5,467.6,587.9,467.1,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M471.7,587.9L471.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C472.6,587.5,472.2,587.9,471.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M476.4,587.9L476.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C477.3,587.5,476.9,587.9,476.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M481,587.9L481,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V587        C482,587.5,481.6,587.9,481,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M485.7,587.9L485.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C486.6,587.5,486.2,587.9,485.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M490.4,587.9L490.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C491.3,587.5,490.9,587.9,490.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M495,587.9L495,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V587        C496,587.5,495.6,587.9,495,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M499.7,587.9L499.7,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C500.6,587.5,500.2,587.9,499.7,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M504.4,587.9L504.4,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V587C505.3,587.5,504.9,587.9,504.4,587.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M509,587.9L509,587.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V587        C510,587.5,509.6,587.9,509,587.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 408.8,
    y: 567.6,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.8,
    y: 589.6,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 464.7,
    y: 567.6,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.4,493.6c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H388.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M507.1,491.1v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H392.3c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C506.8,492.9,507.1,492,507.1,491.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M391.5,491.9L391.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C392.5,491.5,392,491.9,391.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M396.2,491.9L396.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C397.1,491.5,396.7,491.9,396.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M400.9,491.9L400.9,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C401.8,491.5,401.4,491.9,400.9,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M405.5,491.9L405.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C406.5,491.5,406,491.9,405.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M410.2,491.9L410.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C411.1,491.5,410.7,491.9,410.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M414.9,491.9L414.9,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C415.8,491.5,415.4,491.9,414.9,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.5,491.9L419.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C420.5,491.5,420,491.9,419.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M424.2,491.9L424.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C425.1,491.5,424.7,491.9,424.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M428.9,491.9L428.9,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C429.8,491.5,429.4,491.9,428.9,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M433.5,491.9L433.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C434.5,491.5,434,491.9,433.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M438.2,491.9L438.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C439.1,491.5,438.7,491.9,438.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M442.9,491.9L442.9,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C443.8,491.5,443.4,491.9,442.9,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M447.5,491.9L447.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C448.5,491.5,448,491.9,447.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M452.2,491.9L452.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C453.1,491.5,452.7,491.9,452.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M456.9,491.9L456.9,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C457.8,491.5,457.4,491.9,456.9,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M461.5,491.9L461.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C462.4,491.5,462,491.9,461.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M466.2,491.9L466.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C467.1,491.5,466.7,491.9,466.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M470.8,491.9L470.8,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C471.8,491.5,471.4,491.9,470.8,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M475.5,491.9L475.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C476.4,491.5,476,491.9,475.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M480.2,491.9L480.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C481.1,491.5,480.7,491.9,480.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M484.8,491.9L484.8,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C485.8,491.5,485.4,491.9,484.8,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M489.5,491.9L489.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C490.4,491.5,490,491.9,489.5,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M494.2,491.9L494.2,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C495.1,491.5,494.7,491.9,494.2,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M498.8,491.9L498.8,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C499.8,491.5,499.4,491.9,498.8,491.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M503.5,491.9L503.5,491.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C504.4,491.5,504,491.9,503.5,491.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 471.6,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 493.6,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 459.1,
    y: 471.6,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M396.2,613.6c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H396.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M514.9,611.1v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H400c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C514.6,612.9,514.9,612,514.9,611.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M399.3,611.9L399.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C400.3,611.4,399.8,611.9,399.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M404,611.9L404,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C404.9,611.4,404.5,611.9,404,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M408.7,611.9L408.7,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C409.6,611.4,409.2,611.9,408.7,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M413.3,611.9L413.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C414.3,611.4,413.8,611.9,413.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M418,611.9L418,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C418.9,611.4,418.5,611.9,418,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M422.7,611.9L422.7,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C423.6,611.4,423.2,611.9,422.7,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M427.3,611.9L427.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C428.2,611.4,427.8,611.9,427.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M432,611.9L432,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C432.9,611.4,432.5,611.9,432,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M436.6,611.9L436.6,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C437.6,611.4,437.2,611.9,436.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.3,611.9L441.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C442.2,611.4,441.8,611.9,441.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M446,611.9L446,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C446.9,611.4,446.5,611.9,446,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M450.6,611.9L450.6,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C451.6,611.4,451.2,611.9,450.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M455.3,611.9L455.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C456.2,611.4,455.8,611.9,455.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M460,611.9L460,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C460.9,611.4,460.5,611.9,460,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M464.6,611.9L464.6,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C465.6,611.4,465.2,611.9,464.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M469.3,611.9L469.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C470.2,611.4,469.8,611.9,469.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M474.3,611.9h-0.7c-0.3,0-0.6-0.3-0.6-0.6v-17.5c0-0.3,0.3-0.6,0.6-0.6h0.7c0.3,0,0.6,0.3,0.6,0.6v17.5        C474.9,611.6,474.6,611.9,474.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M478.6,611.9L478.6,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C479.6,611.4,479.1,611.9,478.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M483.3,611.9L483.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C484.2,611.4,483.8,611.9,483.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M488,611.9L488,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C488.9,611.4,488.5,611.9,488,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M492.6,611.9L492.6,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C493.6,611.4,493.1,611.9,492.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M497.3,611.9L497.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C498.2,611.4,497.8,611.9,497.3,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M502,611.9L502,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C502.9,611.4,502.5,611.9,502,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M506.6,611.9L506.6,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C507.6,611.4,507.1,611.9,506.6,611.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M511.3,611.9L511.3,611.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C512.2,611.4,511.8,611.9,511.3,611.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 591.6,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 613.6,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 466.9,
    y: 591.6,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M399.5,517.6c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H399.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M518.3,515.1v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H403.4c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C518,516.9,518.3,516,518.3,515.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.7,515.9L402.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C403.6,515.4,403.2,515.9,402.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M407.3,515.9L407.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C408.3,515.4,407.9,515.9,407.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M412,515.9L412,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412.9,515.4,412.5,515.9,412,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M416.7,515.9L416.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C417.6,515.4,417.2,515.9,416.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M421.3,515.9L421.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C422.3,515.4,421.9,515.9,421.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M426,515.9L426,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426.9,515.4,426.5,515.9,426,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M430.7,515.9L430.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C431.6,515.4,431.2,515.9,430.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M435.3,515.9L435.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C436.3,515.4,435.9,515.9,435.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M440,515.9L440,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440.9,515.4,440.5,515.9,440,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M444.7,515.9L444.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C445.6,515.4,445.2,515.9,444.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M449.3,515.9L449.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C450.3,515.4,449.9,515.9,449.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M454,515.9L454,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C454.9,515.4,454.5,515.9,454,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M458.7,515.9L458.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C459.6,515.4,459.2,515.9,458.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M463.3,515.9L463.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C464.3,515.4,463.8,515.9,463.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M468,515.9L468,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C468.9,515.4,468.5,515.9,468,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M472.7,515.9L472.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C473.6,515.4,473.2,515.9,472.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M477.3,515.9L477.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C478.3,515.4,477.8,515.9,477.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M482,515.9L482,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C482.9,515.4,482.5,515.9,482,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M486.7,515.9L486.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C487.6,515.4,487.2,515.9,486.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M491.3,515.9L491.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C492.3,515.4,491.8,515.9,491.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M496,515.9L496,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C496.9,515.4,496.5,515.9,496,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M500.7,515.9L500.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C501.6,515.4,501.2,515.9,500.7,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M505.3,515.9L505.3,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C506.3,515.4,505.8,515.9,505.3,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M510,515.9L510,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C510.9,515.4,510.5,515.9,510,515.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M514.7,515.9L514.7,515.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C515.6,515.4,515.2,515.9,514.7,515.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.4,
    y: 495.6,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.4,
    y: 517.6,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 470.3,
    y: 495.6,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398.6,565.5c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M517.3,563v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H402.5c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C517,564.8,517.3,563.9,517.3,563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M401.7,563.8L401.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C402.7,563.4,402.2,563.8,401.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.4,563.8L406.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C407.3,563.4,406.9,563.8,406.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.1,563.8L411.1,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C412,563.4,411.6,563.8,411.1,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.7,563.8L415.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C416.7,563.4,416.2,563.8,415.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M420.4,563.8L420.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C421.3,563.4,420.9,563.8,420.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M425.1,563.8L425.1,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C426,563.4,425.6,563.8,425.1,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M429.7,563.8L429.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C430.7,563.4,430.2,563.8,429.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M434.4,563.8L434.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C435.3,563.4,434.9,563.8,434.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M439.1,563.8L439.1,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C440,563.4,439.6,563.8,439.1,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M443.7,563.8L443.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C444.7,563.4,444.2,563.8,443.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M448.4,563.8L448.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C449.3,563.4,448.9,563.8,448.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.1,563.8L453.1,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C454,563.4,453.6,563.8,453.1,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M457.7,563.8L457.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C458.7,563.4,458.2,563.8,457.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M462.4,563.8L462.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C463.3,563.4,462.9,563.8,462.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.1,563.8L467.1,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C468,563.4,467.6,563.8,467.1,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M471.7,563.8L471.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C472.6,563.4,472.2,563.8,471.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M476.4,563.8L476.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C477.3,563.4,476.9,563.8,476.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M481,563.8L481,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v16.8        C482,563.4,481.6,563.8,481,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M485.7,563.8L485.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C486.6,563.4,486.2,563.8,485.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M490.4,563.8L490.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C491.3,563.4,490.9,563.8,490.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M495,563.8L495,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v16.8        C496,563.4,495.6,563.8,495,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M499.7,563.8L499.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C500.6,563.4,500.2,563.8,499.7,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M504.4,563.8L504.4,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C505.3,563.4,504.9,563.8,504.4,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M509,563.8L509,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v16.8        C510,563.4,509.6,563.8,509,563.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M513.7,563.8L513.7,563.8c-0.5,0-0.9-0.4-0.9-0.9V546c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C514.6,563.4,514.2,563.8,513.7,563.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 413.4,
    y: 543.5,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.4,
    y: 565.5,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 469.3,
    y: 543.5,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.6,469.6c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M520.3,467.2v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H405.5c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C520,468.9,520.3,468.1,520.3,467.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M404.7,467.9L404.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C405.7,467.5,405.2,467.9,404.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M409.4,467.9L409.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C410.3,467.5,409.9,467.9,409.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M414.1,467.9L414.1,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C415,467.5,414.6,467.9,414.1,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M418.7,467.9L418.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C419.7,467.5,419.2,467.9,418.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M423.4,467.9L423.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C424.3,467.5,423.9,467.9,423.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M428.1,467.9L428.1,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C429,467.5,428.6,467.9,428.1,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M432.7,467.9L432.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C433.7,467.5,433.2,467.9,432.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M437.4,467.9L437.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C438.3,467.5,437.9,467.9,437.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M442.1,467.9L442.1,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C443,467.5,442.6,467.9,442.1,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M446.7,467.9L446.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C447.7,467.5,447.2,467.9,446.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M451.4,467.9L451.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C452.3,467.5,451.9,467.9,451.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M456.1,467.9L456.1,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C457,467.5,456.6,467.9,456.1,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M460.7,467.9L460.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C461.7,467.5,461.2,467.9,460.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M465.4,467.9L465.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C466.3,467.5,465.9,467.9,465.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M470,467.9L470,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V467        C471,467.5,470.6,467.9,470,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M474.7,467.9L474.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C475.6,467.5,475.2,467.9,474.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M479.4,467.9L479.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C480.3,467.5,479.9,467.9,479.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M484,467.9L484,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V467        C485,467.5,484.6,467.9,484,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M488.7,467.9L488.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C489.6,467.5,489.2,467.9,488.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M493.4,467.9L493.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C494.3,467.5,493.9,467.9,493.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M498,467.9L498,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V467        C499,467.5,498.6,467.9,498,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M502.7,467.9L502.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C503.6,467.5,503.2,467.9,502.7,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M507.4,467.9L507.4,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C508.3,467.5,507.9,467.9,507.4,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M512,467.9L512,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9V467        C513,467.5,512.6,467.9,512,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M516.7,467.9L516.7,467.9c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        V467C517.6,467.5,517.2,467.9,516.7,467.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.4,
    y: 447.7,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.4,
    y: 469.6,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 472.3,
    y: 447.7,
    className: "st10",
    width: 41.9,
    height: 22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.7,567.1c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H235.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M354.5,564.6v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H239.6c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C354.2,566.3,354.5,565.5,354.5,564.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.9,565.3L238.9,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C239.8,564.9,239.4,565.3,238.9,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243.5,565.3L243.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C244.5,564.9,244,565.3,243.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.2,565.3L248.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C249.1,564.9,248.7,565.3,248.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.9,565.3L252.9,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C253.8,564.9,253.4,565.3,252.9,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M257.5,565.3L257.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C258.5,564.9,258,565.3,257.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262.2,565.3L262.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C263.1,564.9,262.7,565.3,262.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266.9,565.3L266.9,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C267.8,564.9,267.4,565.3,266.9,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.5,565.3L271.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C272.5,564.9,272,565.3,271.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276.2,565.3L276.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C277.1,564.9,276.7,565.3,276.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M280.9,565.3L280.9,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281.8,564.9,281.4,565.3,280.9,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.5,565.3L285.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C286.5,564.9,286,565.3,285.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.2,565.3L290.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C291.1,564.9,290.7,565.3,290.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.9,565.3L294.9,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C295.8,564.9,295.4,565.3,294.9,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.5,565.3L299.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C300.5,564.9,300,565.3,299.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.2,565.3L304.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C305.1,564.9,304.7,565.3,304.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308.8,565.3L308.8,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C309.8,564.9,309.4,565.3,308.8,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.5,565.3L313.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C314.4,564.9,314,565.3,313.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.2,565.3L318.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C319.1,564.9,318.7,565.3,318.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.8,565.3L322.8,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C323.8,564.9,323.4,565.3,322.8,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.5,565.3L327.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C328.4,564.9,328,565.3,327.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.2,565.3L332.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C333.1,564.9,332.7,565.3,332.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336.8,565.3L336.8,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C337.8,564.9,337.4,565.3,336.8,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M341.5,565.3L341.5,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C342.4,564.9,342,565.3,341.5,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.2,565.3L346.2,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C347.1,564.9,346.7,565.3,346.2,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.8,565.3L350.8,565.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351.8,564.9,351.4,565.3,350.8,565.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.6,
    y: 545.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.6,
    y: 567.1,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 545.1,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.2,615.1c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M363,612.6v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H248.1c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C362.7,614.4,363,613.6,363,612.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M247.4,613.4L247.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C248.3,613,247.9,613.4,247.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.1,613.4L252.1,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C253,613,252.6,613.4,252.1,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256.7,613.4L256.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C257.7,613,257.2,613.4,256.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.4,613.4L261.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C262.3,613,261.9,613.4,261.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266,613.4L266,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C267,613,266.6,613.4,266,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M270.7,613.4L270.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C271.6,613,271.2,613.4,270.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.4,613.4L275.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C276.3,613,275.9,613.4,275.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M280,613.4L280,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281,613,280.6,613.4,280,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M284.7,613.4L284.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C285.6,613,285.2,613.4,284.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M289.4,613.4L289.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C290.3,613,289.9,613.4,289.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294,613.4L294,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C295,613,294.6,613.4,294,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M298.7,613.4L298.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C299.6,613,299.2,613.4,298.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.4,613.4L303.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C304.3,613,303.9,613.4,303.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308,613.4L308,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C309,613,308.5,613.4,308,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M312.7,613.4L312.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C313.6,613,313.2,613.4,312.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.4,613.4L317.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C318.3,613,317.9,613.4,317.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322,613.4L322,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C323,613,322.5,613.4,322,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M326.7,613.4L326.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C327.6,613,327.2,613.4,326.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.4,613.4L331.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C332.3,613,331.9,613.4,331.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336,613.4L336,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C337,613,336.5,613.4,336,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M340.7,613.4L340.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C341.6,613,341.2,613.4,340.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.4,613.4L345.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.3,613,345.9,613.4,345.4,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350,613.4L350,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351,613,350.5,613.4,350,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M354.7,613.4L354.7,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C355.6,613,355.2,613.4,354.7,613.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.4,613.4L359.4,613.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.3,613,359.9,613.4,359.4,613.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.1,
    y: 593.2,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.1,
    y: 615.1,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 593.2,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M246.5,639.1c0.8,1.3,2.3,2.1,3.9,2.1h110.2c1.6,0,3-0.9,3.9-2.1H246.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M365.2,636.6v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H250.4c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C365,638.4,365.2,637.5,365.2,636.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M249.6,637.4L249.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C250.6,636.9,250.2,637.4,249.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M254.3,637.4L254.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C255.2,636.9,254.8,637.4,254.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M259,637.4L259,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C259.9,636.9,259.5,637.4,259,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M263.6,637.4L263.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C264.6,636.9,264.2,637.4,263.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.3,637.4L268.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C269.2,636.9,268.8,637.4,268.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M273,637.4L273,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C273.9,636.9,273.5,637.4,273,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M277.6,637.4L277.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C278.6,636.9,278.1,637.4,277.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M282.3,637.4L282.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C283.2,636.9,282.8,637.4,282.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287,637.4L287,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C287.9,636.9,287.5,637.4,287,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.6,637.4L291.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C292.6,636.9,292.1,637.4,291.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M296.3,637.4L296.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C297.2,636.9,296.8,637.4,296.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M301,637.4L301,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C301.9,636.9,301.5,637.4,301,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M305.6,637.4L305.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C306.6,636.9,306.1,637.4,305.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M310.3,637.4L310.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C311.2,636.9,310.8,637.4,310.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M315,637.4L315,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C315.9,636.9,315.5,637.4,315,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M319.6,637.4L319.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C320.6,636.9,320.1,637.4,319.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M324.6,637.4h-0.7c-0.3,0-0.6-0.3-0.6-0.6v-17.5c0-0.3,0.3-0.6,0.6-0.6h0.7c0.3,0,0.6,0.3,0.6,0.6v17.5        C325.2,637.1,325,637.4,324.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M329,637.4L329,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C329.9,636.9,329.5,637.4,329,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333.6,637.4L333.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C334.6,636.9,334.1,637.4,333.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.3,637.4L338.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C339.2,636.9,338.8,637.4,338.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M342.9,637.4L342.9,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C343.9,636.9,343.5,637.4,342.9,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M347.6,637.4L347.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C348.5,636.9,348.1,637.4,347.6,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M352.3,637.4L352.3,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C353.2,636.9,352.8,637.4,352.3,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M356.9,637.4L356.9,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C357.9,636.9,357.5,637.4,356.9,637.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M361.6,637.4L361.6,637.4c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C362.5,636.9,362.1,637.4,361.6,637.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.3,
    y: 617.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.3,
    y: 639.1,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 317.2,
    y: 617.1,
    className: "st10",
    width: 41.9,
    height: 22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.9,591c0.8,1.3,2.3,2.1,3.9,2.1H363c1.6,0,3-0.9,3.9-2.1H248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M367.6,588.5v-0.5v-14.4c0-2.5-2.1-4.6-4.6-4.6H252.8c-2.5,0-4.6,2.1-4.6,4.6v14.4v0.5        c0,0.9,0.3,1.8,0.7,2.5h118C367.4,590.3,367.6,589.5,367.6,588.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.1,589.3L252.1,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C253,588.9,252.6,589.3,252.1,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256.7,589.3L256.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C257.7,588.9,257.2,589.3,256.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.4,589.3L261.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C262.3,588.9,261.9,589.3,261.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266,589.3L266,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C267,588.9,266.6,589.3,266,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M270.7,589.3L270.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C271.6,588.9,271.2,589.3,270.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275.4,589.3L275.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C276.3,588.9,275.9,589.3,275.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M280,589.3L280,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C281,588.9,280.6,589.3,280,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M284.7,589.3L284.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C285.6,588.9,285.2,589.3,284.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M289.4,589.3L289.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C290.3,588.9,289.9,589.3,289.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294,589.3L294,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C295,588.9,294.6,589.3,294,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M298.7,589.3L298.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C299.6,588.9,299.2,589.3,298.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.4,589.3L303.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C304.3,588.9,303.9,589.3,303.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308,589.3L308,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C309,588.9,308.5,589.3,308,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M312.7,589.3L312.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C313.6,588.9,313.2,589.3,312.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.4,589.3L317.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C318.3,588.9,317.9,589.3,317.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322,589.3L322,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C323,588.9,322.5,589.3,322,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M326.7,589.3L326.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C327.6,588.9,327.2,589.3,326.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.4,589.3L331.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C332.3,588.9,331.9,589.3,331.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336,589.3L336,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C337,588.9,336.5,589.3,336,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M340.7,589.3L340.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C341.6,588.9,341.2,589.3,340.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.4,589.3L345.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C346.3,588.9,345.9,589.3,345.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350,589.3L350,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C351,588.9,350.5,589.3,350,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M354.7,589.3L354.7,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C355.6,588.9,355.2,589.3,354.7,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M359.4,589.3L359.4,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C360.3,588.9,359.9,589.3,359.4,589.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364,589.3L364,589.3c-0.5,0-0.9-0.4-0.9-0.9v-16.8c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9        v16.8C365,588.9,364.5,589.3,364,589.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 263.8,
    y: 569.1,
    className: "st8",
    width: 9.1,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.8,
    y: 591,
    className: "st9",
    width: 9.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 319.6,
    y: 569.1,
    className: "st10",
    width: 41.9,
    height: 22
  }))))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -122.5637 391.7922)",
    className: "st7",
    cx: 411.7,
    cy: 343.8,
    rx: 59.8,
    ry: 59.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 409.9,
    cy: 341.8,
    r: 59.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 409.9,
    cy: 341.8,
    r: 50.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M364.6,339.3c0.3-0.1,0.4-0.3,0.4-0.6c0.3-3.3,0.9-6.7,1.9-10c0.5-1.8,1.2-3.5,1.8-4.8    c0.1-0.3,0.2-0.5,0.4-0.8c0.2-0.5,0.5-1,0.7-1.5c0.1-0.2,0.3-0.5,0.4-0.7c0.3-0.5,0.5-1,0.8-1.5c0.1-0.2,0.1-0.5,0-0.7    c-0.2-0.4-0.8-0.7-1.2-0.7c-0.1,0-0.2,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.5-0.6,1.1-0.9,1.6c-0.1,0.2-0.3,0.5-0.4,0.7    c-0.3,0.5-0.5,1.1-0.8,1.6c-0.1,0.3-0.2,0.5-0.4,0.8c-0.6,1.3-1.3,3.1-1.8,5c-1.1,3.4-1.7,7-2,10.5c0,0.3,0.1,0.5,0.4,0.7    C363.6,339.4,364.2,339.5,364.6,339.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M375.5,329.2c0.3,0.4,1,0.6,1.4,0.5c0.2,0,0.4-0.2,0.5-0.4c1.4-3.6,3.4-7,5.9-10c2.6-3.1,5.6-5.6,8.8-7.5    c0.4-0.3,0.3-0.9,0-1.3c-0.3-0.5-0.7-0.7-1-0.6c0,0,0,0-0.1,0c-3.5,2-6.6,4.7-9.4,7.9l0,0c-2.7,3.2-4.8,6.8-6.3,10.6    C375.3,328.8,375.4,329.1,375.5,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.5,336.3c-0.3,0-0.6,0-0.8,0.1c-0.2,0.1-0.3,0.2-0.4,0.5c-1.2,8.1,0.5,16.6,4.7,23.8l0,0    c0.1,0.2,0.3,0.3,0.6,0.3c0.5,0,1.1-0.4,1.3-0.8c0.1-0.2,0.1-0.4,0-0.6c-4-6.8-5.5-14.8-4.4-22.4    C375.5,336.8,375.1,336.4,374.5,336.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M366.7,360c0.4,0.1,1-0.2,1.3-0.5c0.2-0.2,0.2-0.5,0.1-0.7c-0.2-0.5-0.4-1-0.6-1.5c-0.1-0.3-0.2-0.6-0.3-0.9    c-0.2-0.5-0.3-1-0.5-1.6c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.5-0.3-1-0.4-1.6l-0.2-1.3    c-0.1-0.5-0.2-0.9-0.2-1.2c-0.1-0.5-0.6-0.7-1.2-0.6c-0.2,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.6,0.5-0.5,0.8c0.1,0.4,0.1,0.8,0.2,1.3    l0.3,1.3c0.1,0.6,0.3,1.1,0.4,1.7c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.6,0.3,1.1,0.5,1.7    c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.4,1.1,0.6,1.6C366.2,359.8,366.4,360,366.7,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M369.8,364.5c-0.1,0-0.1,0-0.2,0.1c-0.6,0.3-0.8,0.8-0.5,1.2c1.8,3.1,3.9,5.9,6.4,8.5    c0.3,0.3,0.9,0.3,1.3-0.1c0.4-0.4,0.6-1,0.3-1.4c-2.3-2.5-4.4-5.2-6.1-8.1C370.8,364.4,370.3,364.3,369.8,364.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.6,365.9c-0.1-0.1-0.3-0.2-0.6-0.1c-0.1,0-0.1,0-0.2,0.1c-0.4,0.2-0.8,0.6-0.9,1c-0.1,0.2,0,0.4,0.1,0.6    c1.9,2.1,4.1,3.9,6.4,5.4c0.2,0.1,0.4,0.1,0.6,0c0.4-0.2,0.8-0.8,0.8-1.3c0-0.2-0.1-0.4-0.2-0.5    C388.4,369.6,386.4,367.8,384.6,365.9z M384.4,366.1L384.4,366.1L384.4,366.1L384.4,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M387.1,351.1c-0.2-0.4-0.8-0.3-1.3-0.1c0,0,0,0,0,0c-0.6,0.2-0.8,0.6-0.7,0.9c0.8,1.9,1.7,3.7,2.9,5.4    c0.2,0.3,0.6,0.3,1.2-0.1c0.5-0.3,0.9-0.8,0.6-1.1C388.7,354.6,387.8,352.9,387.1,351.1L387.1,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M385.5,304.1c2-1.3,4.1-2.4,6.4-3.4c0,0,0,0,0,0c4.2-1.9,8.8-3.1,13.5-3.6c1.1-0.1,2.1-0.2,3.1-0.2l0.2,0    c0.4,0,0.7,0,1.1,0l0.3,0c0.4,0,0.7,0,1.1,0l0.2,0c0.5,0,1.1,0,1.6,0.1l0.1,0c0.3,0,0.5,0,0.8,0.1l0.3,0c1,0.1,2,0.2,3,0.4    c8.5,1.4,16.7,5.3,23.1,11c0.2,0.2,0.4,0.2,0.6,0.2c0,0.2,0,0.4,0.2,0.6c2.5,2.3,4.7,4.9,6.6,7.8c0.1,0.2,0.4,0.3,0.7,0.3    c0.5,0,1-0.4,1.2-0.8c0.1-0.3,0.1-0.5,0-0.8c-2-3-4.3-5.7-6.9-8.1c-0.2-0.2-0.4-0.2-0.6-0.2c0-0.2-0.1-0.4-0.2-0.6    c-0.9-0.8-1.9-1.6-2.8-2.3l-1.7-1.2c-0.3-0.2-0.7-0.5-1-0.7c-0.2-0.1-0.4-0.2-0.6-0.4c-6.1-3.9-13.2-6.4-20.4-7.2l-0.1,0    c-0.6-0.1-1.1-0.1-1.7-0.1l-0.4,0c-0.3,0-0.7,0-1-0.1c-0.2,0-0.5,0-0.7,0c-0.3,0-0.6,0-0.9,0l-0.2,0c-0.1,0-0.2,0-0.3,0    c-0.1,0-0.3,0-0.4,0l-0.4,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.6,0-1,0l-0.6,0c-0.3,0-0.6,0-0.9,0.1c-0.3,0-0.6,0.1-0.9,0.1l-0.2,0    c-0.1,0-0.2,0-0.4,0l-0.2,0c-4.8,0.6-9.5,1.9-13.9,3.9c-2.2,1-4.3,2.1-6.3,3.4l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.5,0.4,1,0.8,1.2    C385,304.2,385.3,304.2,385.5,304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M455.7,341.9c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.4-0.4,0.6c0,3.3-0.5,6.7-1.3,10.1c-0.4,1.8-1,3.6-1.5,4.9    c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.5-0.4,1-0.6,1.5c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.5-0.5,1.1-0.7,1.6c-0.1,0.2-0.1,0.5,0.1,0.7    c0.2,0.4,0.8,0.7,1.2,0.6c0.3,0,0.5-0.2,0.6-0.4c0.3-0.5,0.5-1.1,0.8-1.7c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.5,0.5-1.1,0.7-1.7    c0.1-0.3,0.2-0.5,0.3-0.8c0.5-1.4,1.1-3.2,1.5-5.1c0.8-3.5,1.3-7.1,1.4-10.6l0,0c0-0.3-0.1-0.5-0.4-0.6    C456.6,341.7,456.1,341.7,455.7,341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M443.8,352.2c-0.1,0-0.1,0-0.1,0c-0.2,0.1-0.3,0.2-0.3,0.3c-1.2,3.7-3,7.2-5.3,10.3c-2.4,3.2-5.2,5.9-8.4,8    c-0.4,0.3-0.2,0.9,0.1,1.3c0.4,0.5,0.8,0.7,1.1,0.5c3.3-2.2,6.3-5.1,8.9-8.5c2.5-3.4,4.4-7.1,5.6-11l0,0c0.1-0.2,0-0.4-0.2-0.6    C445,352.3,444.3,352.1,443.8,352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M445.2,345.2c0.4,0.3,1.1,0.3,1.5,0.1c0,0,0,0,0,0c0.2-0.1,0.4-0.3,0.4-0.5c0.7-8.2-1.5-16.6-6.1-23.5l0,0    c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.5-0.8,0.8c-0.1,0.2-0.1,0.4,0,0.6c4.4,6.6,6.4,14.4,5.8,22.1    C444.9,344.9,445,345.1,445.2,345.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M451,322c-0.2,0.2-0.2,0.5-0.1,0.7c0.2,0.5,0.5,1,0.7,1.5c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.5,0.4,1,0.6,1.5    c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.3,1,0.5,1.6l0.3,1.2c0.1,0.5,0.2,0.9,0.3,1.2    c0.1,0.5,0.6,0.7,1.2,0.6c0.6-0.1,1-0.6,0.9-1c-0.1-0.4-0.2-0.8-0.3-1.3l-0.3-1.3c-0.2-0.6-0.3-1.1-0.5-1.7    c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3-0.2-0.6-0.3-0.9c-0.2-0.5-0.4-1.1-0.6-1.6c-0.1-0.3-0.2-0.6-0.4-0.9c-0.2-0.5-0.4-1.1-0.7-1.6    c-0.1-0.2-0.3-0.4-0.6-0.4c-0.2,0-0.4,0-0.6,0.1C451.3,321.6,451.1,321.8,451,322z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M428.9,310c-0.2-0.1-0.3-0.1-0.5,0c0,0-0.1,0-0.1,0c-0.4,0.2-0.8,0.9-0.8,1.3c0,0.2,0.1,0.4,0.3,0.5    c2.2,1.3,4.3,2.9,6.3,4.7c0.1,0.1,0.3,0.2,0.6,0.1c0.4-0.1,1-0.7,1.1-1.1c0.1-0.2,0-0.4-0.1-0.6C433.5,313,431.2,311.3,428.9,310z    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M429.5,326.7c1.1,1.5,2.1,3.1,2.9,4.8c0.2,0.4,0.8,0.2,1.3,0c0.6-0.3,0.8-0.6,0.6-0.9c-0.9-1.8-2-3.6-3.2-5.2    c-0.2-0.2-0.4-0.2-0.7-0.1c-0.1,0.1-0.3,0.1-0.4,0.3C429.6,325.8,429.2,326.3,429.5,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M383.5,381.2l1.7,1.1c0.3,0.2,0.7,0.4,1.1,0.6c0.2,0.1,0.4,0.2,0.6,0.3c4.6,2.6,9.7,4.4,15,5.3    c0.1,0,0.1,0,0.2,0c1.8,0.3,3.7,0.5,5.6,0.6l0.5,0c0.3,0,0.7,0,1,0l0.6,0c0.5,0,0.9,0,1.4,0l0.1,0c0.5,0,0.9,0,1.4-0.1l0.2,0    c8.9-0.5,17.9-3.8,25.2-9.2l0,0c0.2-0.2,0.3-0.4,0.3-0.7c-0.1-0.5-0.4-0.9-0.9-1.1c-0.3-0.1-0.5-0.1-0.7,0.1    c-1.9,1.4-4,2.7-6.2,3.8c-5.6,2.9-12,4.6-18.4,5c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0c-0.3,0-0.5,0-0.8,0l-0.6,0    c-0.4,0-0.9,0-1.3,0l-0.1,0c-0.2,0-0.5,0-0.7,0l-0.5,0c-0.4,0-0.8-0.1-1.2-0.1l-0.2,0c-8.5-0.9-16.9-4.3-23.6-9.6    c-0.2-0.2-0.5-0.2-0.8-0.1c-0.2,0.1-0.4,0.2-0.5,0.4c-0.4,0.5-0.4,1,0,1.3C381.5,379.8,382.5,380.5,383.5,381.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M432.4,354c-0.2-5.8-2.7-10.6-7.5-14c-2.2-1.5-4.6-2.6-7-3.5c-2.7-1.1-5.7-1.7-8.3-3.1   c-1.7-0.9-3.1-1.8-3.8-3.3c0,0-0.1-0.5-0.2-0.7c0-0.1-0.1-0.4,0-0.5c0.1-0.9,0.4-1.6,1.1-2.2c4-3.7,11.1-1.7,15.3,0.4   c1.6,0.8,3.7,0.5,4.7-1.3c1-1.9,2-3.7,3-5.6c0.9-1.6,0.4-3.7-1.3-4.7c-3.8-2.3-8.5-3.7-13.1-4c0-0.2,0.1-0.4,0.1-0.7l0-4.3   c0-2.3-1.9-4.1-4.1-4.1l-0.7,0c-2.3,0-4.1,1.9-4.1,4.1l0,4.3c0,0.5,0.1,0.9,0.2,1.3c-1,0.3-2.1,0.6-3,1   c-7.4,2.9-12.8,9.9-11.7,18.2c0.9,7,6.2,11.7,12.3,14.5c3.7,1.7,7.8,2.5,11.2,4.7c0.9,0.6,1.8,1.5,2.3,2.1c0.6,1,0.8,1.5,0.7,2.9   c-0.3,3.8-4.5,4.8-7.7,4.9c-4.7,0.2-9-1.5-12.8-4.3c-1.4-1-3.9-0.3-4.7,1.3c-1,2.1-2,4.3-3,6.4c-0.8,1.7-0.4,3.6,1.3,4.7   c4.2,2.6,8.9,4.3,13.8,4.9l0,4.2c0,2.3,1.9,4.1,4.1,4.1l0.7,0c2.3,0,4.1-1.9,4.1-4.1l0-4.2c1.2-0.2,2.4-0.4,3.5-0.8   c8.2-2.4,14.4-8.9,14.6-17.6c0-0.1,0-0.3,0-0.4C432.4,354.3,432.4,354.2,432.4,354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.979 -0.204 0.204 0.979 -115.4965 60.0554)",
    className: "st7",
    cx: 233.6,
    cy: 590.4,
    rx: 59.8,
    ry: 59.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 231.3,
    cy: 589,
    r: 59.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -348.7225 336.1003)",
    className: "st7",
    cx: 231.3,
    cy: 589,
    rx: 50.5,
    ry: 50.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.4,600.4c0.2-0.2,0.3-0.4,0.2-0.7c-0.8-3.3-1.2-6.7-1.3-10.1c0-1.8,0.1-3.7,0.2-5.1     c0-0.3,0.1-0.6,0.1-0.9c0.1-0.6,0.1-1.1,0.2-1.6c0.1-0.3,0.1-0.5,0.1-0.8c0.1-0.6,0.2-1.1,0.3-1.7c0.1-0.3,0-0.5-0.2-0.7     c-0.3-0.3-0.9-0.4-1.4-0.3c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.4c-0.1,0.6-0.3,1.2-0.4,1.8c0,0.3-0.1,0.5-0.1,0.8     c-0.1,0.6-0.2,1.2-0.2,1.8c0,0.3-0.1,0.6-0.1,0.9c-0.1,1.5-0.3,3.4-0.2,5.3c0.1,3.6,0.5,7.2,1.3,10.6c0.1,0.3,0.3,0.4,0.6,0.5     C186.5,600.9,187.1,600.8,187.4,600.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194.8,587.5c0.4,0.2,1.1,0.3,1.5,0.1c0.2-0.1,0.3-0.3,0.3-0.5c0.2-3.9,1.1-7.7,2.6-11.3     c1.6-3.7,3.6-7,6.1-9.8c0.3-0.4,0-0.9-0.4-1.3c-0.5-0.4-0.9-0.5-1.2-0.2c0,0,0,0-0.1,0.1c-2.7,3-4.9,6.5-6.5,10.4l0,0     c-1.6,3.9-2.5,7.9-2.7,12C194.5,587.2,194.6,587.4,194.8,587.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.9,594.6c-0.3,0.1-0.6,0.2-0.8,0.3c-0.2,0.2-0.2,0.3-0.2,0.5c1.4,8.1,5.6,15.7,11.8,21.3l0,0     c0.2,0.1,0.4,0.2,0.6,0.1c0.4-0.2,0.9-0.7,1-1.2c0-0.2,0-0.4-0.2-0.6c-5.9-5.3-9.8-12.4-11.1-20     C197,594.7,196.6,594.5,195.9,594.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.8,619.6c0.4-0.1,0.9-0.5,1.1-0.9c0.1-0.3,0.1-0.5-0.1-0.7c-0.4-0.4-0.7-0.8-1-1.3     c-0.2-0.2-0.4-0.5-0.6-0.7c-0.3-0.4-0.6-0.9-0.9-1.3c-0.2-0.3-0.3-0.5-0.5-0.7c-0.2-0.3-0.3-0.5-0.5-0.8     c-0.3-0.5-0.6-0.9-0.8-1.4l-0.6-1.1c-0.2-0.4-0.4-0.8-0.6-1.1c-0.2-0.4-0.8-0.5-1.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2     c-0.3,0.3-0.4,0.6-0.3,1c0.2,0.4,0.4,0.8,0.6,1.2l0.6,1.2c0.3,0.5,0.6,1,0.9,1.5c0.2,0.3,0.3,0.5,0.5,0.8     c0.2,0.2,0.3,0.5,0.5,0.8c0.3,0.5,0.7,1,1,1.4c0.2,0.2,0.4,0.5,0.6,0.7c0.3,0.5,0.7,0.9,1.1,1.4     C195.3,619.5,195.5,619.6,195.8,619.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M200.2,622.9c0,0-0.1,0.1-0.1,0.1c-0.4,0.5-0.5,1-0.1,1.4c2.7,2.4,5.6,4.5,8.7,6.2c0.4,0.2,0.9,0,1.2-0.5     c0.3-0.5,0.3-1.1-0.2-1.4c-3-1.6-5.8-3.6-8.3-5.9C201.1,622.4,200.6,622.5,200.2,622.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.6,619.7c-0.1-0.1-0.3-0.1-0.6,0c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0.3-0.6,0.8-0.6,1.2     c0,0.2,0.1,0.4,0.3,0.5c2.5,1.4,5.1,2.4,7.7,3.2c0.2,0.1,0.4,0,0.6-0.2c0.3-0.3,0.5-1,0.4-1.5c-0.1-0.2-0.2-0.4-0.4-0.4     C219.4,622,216.9,621,214.6,619.7z M214.5,619.9L214.5,619.9L214.5,619.9L214.5,619.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.5,604.8c-0.3-0.3-0.9,0-1.3,0.3c0,0,0,0,0,0c-0.5,0.4-0.6,0.8-0.4,1c1.3,1.6,2.8,3,4.4,4.2     c0.3,0.2,0.7,0,1.1-0.5c0.3-0.4,0.6-1,0.3-1.3C215.1,607.6,213.7,606.3,212.5,604.8L212.5,604.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.5,560.5c1.5-1.8,3.2-3.6,5-5.2c0,0,0,0,0,0c3.5-3.1,7.4-5.6,11.7-7.5c1-0.4,1.9-0.8,2.9-1.2l0.2-0.1     c0.3-0.1,0.7-0.2,1-0.4l0.3-0.1c0.3-0.1,0.7-0.2,1-0.3l0.2-0.1c0.5-0.1,1-0.3,1.5-0.4l0.1,0c0.3-0.1,0.5-0.1,0.8-0.2l0.3-0.1     c1-0.2,2-0.4,3-0.6c8.5-1.3,17.5-0.1,25.3,3.4c0.2,0.1,0.4,0.1,0.6,0c0,0.2,0.2,0.4,0.4,0.5c3.1,1.5,6,3.3,8.6,5.4     c0.2,0.2,0.5,0.2,0.7,0.1c0.4-0.2,0.8-0.6,0.9-1.1c0-0.3,0-0.5-0.3-0.7c-2.8-2.2-5.8-4.1-9-5.6c-0.2-0.1-0.4-0.1-0.6,0     c-0.1-0.2-0.2-0.4-0.4-0.5c-1.1-0.5-2.3-0.9-3.4-1.4l-2-0.7c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2-0.1-0.4-0.1-0.6-0.2     c-7-1.9-14.5-2.1-21.6-0.6l-0.1,0c-0.6,0.1-1.1,0.2-1.7,0.4l-0.4,0.1c-0.3,0.1-0.6,0.2-1,0.3c-0.2,0.1-0.4,0.1-0.7,0.2     c-0.3,0.1-0.6,0.2-0.9,0.3l-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.1l-0.4,0.1c-0.2,0.1-0.4,0.1-0.6,0.2     c-0.3,0.1-0.6,0.2-0.9,0.3l-0.5,0.2c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.5,0.2-0.8,0.3l-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.2     l-0.2,0.1c-4.4,2-8.4,4.7-12,7.9c-1.8,1.6-3.5,3.4-5,5.2l0,0c-0.2,0.2-0.2,0.5-0.1,0.8c0.2,0.4,0.7,0.8,1.1,0.9     C196.1,560.8,196.4,560.7,196.5,560.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M275,575C274.9,575,274.9,575.1,275,575c-0.3,0.3-0.3,0.5-0.3,0.8c1,3.2,1.6,6.6,1.9,10     c0.2,1.8,0.1,3.7,0.1,5.1c0,0.3,0,0.6-0.1,0.9c0,0.6-0.1,1.1-0.1,1.7c0,0.3-0.1,0.5-0.1,0.8c-0.1,0.6-0.1,1.1-0.2,1.7     c0,0.3,0.1,0.5,0.3,0.7c0.4,0.3,1,0.4,1.4,0.2c0.3-0.1,0.4-0.3,0.5-0.6c0.1-0.6,0.2-1.2,0.2-1.8c0-0.3,0.1-0.6,0.1-0.8     c0.1-0.6,0.1-1.2,0.1-1.8c0-0.3,0-0.6,0.1-0.9c0-1.5,0.1-3.4-0.1-5.3c-0.3-3.6-0.9-7.1-2-10.5l0,0c-0.1-0.3-0.3-0.4-0.6-0.5     C275.8,574.6,275.3,574.7,275,575z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M266.8,588.4c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,3.9-0.6,7.7-1.9,11.5     c-1.3,3.8-3.2,7.2-5.5,10.2c-0.3,0.4,0.1,0.9,0.5,1.2c0.5,0.4,1,0.4,1.2,0.1c2.5-3.2,4.5-6.8,5.9-10.8c1.3-4,2-8.1,2-12.2l0,0     c0-0.2-0.1-0.4-0.3-0.5C267.9,588.2,267.2,588.2,266.8,588.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.9,581.4c0.4,0.1,1.1,0,1.5-0.3c0,0,0,0,0,0c0.2-0.2,0.3-0.4,0.2-0.6c-1.9-8-6.5-15.3-13.1-20.5l0,0     c-0.2-0.1-0.4-0.1-0.6,0c-0.1,0.1-0.2,0.1-0.4,0.2c-0.3,0.3-0.5,0.7-0.6,1c0,0.2,0,0.4,0.2,0.5c6.2,4.9,10.5,11.8,12.3,19.3     C265.6,581.2,265.7,581.3,265.9,581.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M264.3,557.5c-0.1,0.3,0,0.5,0.2,0.7c0.4,0.4,0.7,0.8,1.1,1.2c0.2,0.2,0.4,0.5,0.6,0.7     c0.3,0.4,0.7,0.8,1,1.3c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.3,0.4,0.5,0.5,0.8c0.3,0.4,0.6,0.9,0.9,1.3l0.7,1.1     c0.3,0.4,0.5,0.7,0.7,1.1c0.2,0.4,0.8,0.5,1.3,0.2c0.6-0.3,0.8-0.8,0.5-1.2c-0.2-0.4-0.4-0.7-0.7-1.2L271,563     c-0.3-0.5-0.7-1-1-1.4c-0.2-0.2-0.4-0.5-0.5-0.8c-0.2-0.2-0.4-0.5-0.6-0.7c-0.4-0.5-0.7-0.9-1.1-1.4c-0.2-0.2-0.4-0.5-0.6-0.7     c-0.4-0.4-0.8-0.9-1.2-1.3c-0.2-0.2-0.4-0.3-0.7-0.2c-0.2,0.1-0.4,0.2-0.6,0.3C264.6,557,264.4,557.2,264.3,557.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239.6,552.9c-0.2,0-0.4,0-0.5,0.2c0,0,0,0-0.1,0.1c-0.3,0.3-0.5,1.1-0.3,1.5c0.1,0.2,0.2,0.4,0.4,0.4     c2.5,0.5,5,1.4,7.4,2.6c0.1,0.1,0.3,0.1,0.6-0.1c0.4-0.3,0.7-0.9,0.7-1.4c0-0.2-0.1-0.4-0.3-0.5     C245,554.3,242.3,553.4,239.6,552.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M245.3,568.6c1.5,1,3,2.3,4.3,3.6c0.3,0.3,0.9,0,1.3-0.4c0.4-0.4,0.6-0.8,0.3-1.1c-1.4-1.5-3-2.8-4.6-3.9     c-0.2-0.1-0.5-0.1-0.7,0.1c-0.1,0.1-0.2,0.2-0.3,0.4C245.2,567.7,244.9,568.3,245.3,568.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.3,634.6l2,0.5c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0,0.4,0.1,0.7,0.1c5.2,1.1,10.6,1.2,15.9,0.5     c0.1,0,0.1,0,0.2,0c1.8-0.3,3.7-0.7,5.6-1.1l0.5-0.1c0.3-0.1,0.7-0.2,1-0.3l0.5-0.2c0.4-0.1,0.9-0.3,1.3-0.4l0.1,0     c0.4-0.2,0.9-0.3,1.3-0.5l0.2-0.1c8.3-3.2,15.8-9.1,21.2-16.4l0,0c0.2-0.2,0.2-0.5,0-0.8c-0.2-0.4-0.7-0.8-1.1-0.8     c-0.3,0-0.5,0.1-0.7,0.3c-1.4,1.9-3,3.8-4.7,5.5c-4.5,4.5-10,8.1-16,10.3c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0.1-0.4,0.2-0.7,0.2     c-0.3,0.1-0.5,0.2-0.8,0.3l-0.5,0.2c-0.4,0.1-0.9,0.3-1.3,0.4l-0.1,0c-0.2,0.1-0.5,0.1-0.7,0.2l-0.5,0.1     c-0.4,0.1-0.8,0.2-1.1,0.3l-0.2,0c-8.4,1.8-17.4,1.1-25.4-1.9c-0.3-0.1-0.5,0-0.8,0.2c-0.2,0.1-0.3,0.4-0.4,0.6     c-0.2,0.6-0.1,1.1,0.4,1.3C216,633.8,217.1,634.2,218.3,634.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.4,593.7c-2-5.4-5.8-9.3-11.4-11c-2.5-0.8-5.2-1.1-7.8-1.2c-3-0.2-5.9,0.1-8.9-0.4    c-1.9-0.3-3.5-0.8-4.6-2c0,0-0.3-0.4-0.4-0.6c-0.1-0.1-0.2-0.4-0.2-0.5c-0.2-0.9-0.1-1.6,0.4-2.4c2.6-4.7,10.1-5,14.7-4.3    c1.8,0.2,3.7-0.7,4.1-2.6c0.4-2.1,0.7-4.2,1.1-6.3c0.3-1.8-0.8-3.6-2.6-4.1c-4.4-1-9.2-0.9-13.7,0.2c0-0.2-0.1-0.4-0.1-0.6    l-1.3-4.1c-0.7-2.1-3-3.3-5.2-2.6l-0.6,0.2c-2.1,0.7-3.3,3-2.6,5.2l1.3,4.1c0.1,0.4,0.3,0.8,0.6,1.2c-0.9,0.6-1.8,1.2-2.6,1.8    c-6.2,5.1-9.1,13.4-5.6,20.9c3,6.3,9.5,9.3,16.2,10.1c4,0.5,8.2-0.1,12.1,1c1.1,0.3,2.2,0.8,2.8,1.3c0.9,0.8,1.2,1.2,1.5,2.5    c0.9,3.7-2.8,6-5.8,7c-4.5,1.6-9,1.3-13.5-0.1c-1.7-0.5-3.8,0.9-4.1,2.6c-0.3,2.3-0.6,4.7-0.9,7c-0.2,1.9,0.7,3.6,2.6,4.1    c4.7,1.2,9.8,1.3,14.7,0.5l1.3,4c0.7,2.1,3,3.3,5.2,2.6l0.6-0.2c2.1-0.7,3.3-3,2.6-5.2l-1.3-4c1.1-0.5,2.1-1.1,3.1-1.8    c7.1-4.8,11-12.9,8.6-21.2c0-0.1-0.1-0.3-0.1-0.4C256.5,594,256.5,593.9,256.4,593.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,354.8c0.8,1.5,0.8,3.4-0.1,5l-61.9,109.3c-0.9,1.6-2.6,2.5-4.3,2.6L351.4,354.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M282.3,471.1l-0.5-0.3l-14.3-8.1c-2.5-1.4-3.4-4.7-2-7.2l61.9-109.3c1.4-2.5,4.7-3.4,7.2-2l14.3,8.1l0.5,0.3     c0.9,0.5,1.6,1.3,2.1,2.1l-66.2,117C284.2,471.8,283.2,471.6,282.3,471.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348,356.9L348,356.9c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C347,357.6,347.7,357.4,348,356.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.3,361.5L345.3,361.5c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C344.4,362.2,345,362,345.3,361.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M342.7,366.2L342.7,366.2c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C341.8,366.8,342.4,366.7,342.7,366.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M340.1,370.8L340.1,370.8c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C339.2,371.5,339.8,371.3,340.1,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.5,375.4L337.5,375.4c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C336.5,376.1,337.2,375.9,337.5,375.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M334.9,380L334.9,380c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C333.9,380.7,334.6,380.5,334.9,380z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.2,384.7L332.2,384.7c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C331.3,385.3,331.9,385.2,332.2,384.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M329.6,389.3L329.6,389.3c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C328.7,390,329.3,389.8,329.6,389.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327,393.9L327,393.9c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C326.1,394.6,326.7,394.4,327,393.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M324.4,398.5L324.4,398.5c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C323.4,399.2,324.1,399,324.4,398.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M321.8,403.2L321.8,403.2c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C320.8,403.8,321.5,403.7,321.8,403.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M319.1,407.8L319.1,407.8c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C318.2,408.5,318.9,408.3,319.1,407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M316.5,412.4L316.5,412.4c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C315.6,413.1,316.2,412.9,316.5,412.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.9,417L313.9,417c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C313,417.7,313.6,417.5,313.9,417z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M311.3,421.7L311.3,421.7c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C310.3,422.4,311,422.2,311.3,421.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308.7,426.3L308.7,426.3c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C307.7,427,308.4,426.8,308.7,426.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M306,430.9L306,430.9c0.3-0.5,0.1-1.2-0.4-1.4L289,420c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C305.1,431.6,305.8,431.4,306,430.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.4,435.5L303.4,435.5c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C302.5,436.2,303.1,436,303.4,435.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M300.8,440.2L300.8,440.2c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C299.9,440.9,300.5,440.7,300.8,440.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M298.2,444.8L298.2,444.8c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C297.2,445.5,297.9,445.3,298.2,444.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M295.6,449.4L295.6,449.4c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C294.6,450.1,295.3,449.9,295.6,449.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M293,454L293,454c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0c-0.3,0.5-0.1,1.2,0.4,1.4     l16.7,9.5C292,454.7,292.7,454.5,293,454z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.3,458.7L290.3,458.7c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C289.4,459.4,290,459.2,290.3,458.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287.7,463.3L287.7,463.3c0.3-0.5,0.1-1.2-0.4-1.4l-16.7-9.5c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C286.8,464,287.4,463.8,287.7,463.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M285.1,467.9L285.1,467.9c0.3-0.5,0.1-1.2-0.4-1.4L268,457c-0.5-0.3-1.2-0.1-1.4,0.4l0,0     c-0.3,0.5-0.1,1.2,0.4,1.4l16.7,9.5C284.2,468.6,284.8,468.4,285.1,467.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 355.3,
    transform: "matrix(0.4928 -0.8702 0.8702 0.4928 -152.8526 473.4322)",
    className: "st8",
    width: 10.3,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.4,
    y: 373.4,
    transform: "matrix(0.4927 -0.8702 0.8702 0.4927 -152.6766 487.2698)",
    className: "st9",
    width: 10.3,
    height: 2.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 265.2,
    y: 427,
    transform: "matrix(-0.4927 0.8702 -0.8702 -0.4927 813.9425 404.5336)",
    className: "st10",
    width: 47.8,
    height: 25
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M657.3,533.3c0.2,35.5-13.1,65-35.2,89.2c-22,23.6-86.3,21.5-86.3,21.5s-64.3,2.1-86.3-21.5    c-22.1-24.2-35.4-53.7-35.2-89.2c0.4-35.1,11.9-75.8,33.2-111.1c21.2-34.7,52.1-64,88.3-63.3c36.2-0.7,67.1,28.6,88.3,63.3    C645.3,457.5,656.8,498.2,657.3,533.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M624,422.3c-21.2-34.7-52.1-64-88.3-63.3c-2.5-0.1-5,0.1-7.5,0.3c20.7,12.3,38.6,33,52.6,55.8   c22.8,37.7,35.1,81.3,35.5,118.8c0.2,38-14,69.6-37.6,95.4c-5.9,6.3-14.6,10.9-24.3,14.2c20.7-1.2,53.2-5.7,67.6-21.1   c22.1-24.2,35.4-53.7,35.2-89.2C656.8,498.2,645.3,457.5,624,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M576,288.4c-3.8,3.3-9.1,3.4-14.5,2l-14.6,65.7h18.5l4.1-13.2l33.3-52.1C602.7,290.7,588.4,277.5,576,288.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M535.8,275.8c0,0-27.9,23.5-40.2,12.6c-12.4-10.9-26.7,2.3-26.7,2.3l33.3,52.1l4.1,13.2h29.6h11.1l14.6-65.7   C549.1,287.1,535.8,275.8,535.8,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M572.2,369.3h-72.8c-2.1,0-3.8-1.7-3.8-3.8v-5.5c0-2.1,1.7-3.8,3.8-3.8h72.8c2.1,0,3.8,1.7,3.8,3.8v5.5   C576,367.6,574.3,369.3,572.2,369.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.4,370.4h-67.3c-4.3,0-7.7-3.5-7.7-7.7c0-4.3,3.5-7.7,7.7-7.7h67.3c4.3,0,7.7,3.5,7.7,7.7   C577.1,366.9,573.7,370.4,569.4,370.4z M502.1,357.2c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5h67.3c3,0,5.5-2.5,5.5-5.5   c0-3-2.5-5.5-5.5-5.5H502.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M572.2,356.1h-72.8c-2.1,0-3.8-1.7-3.8-3.8v-5.5c0-2.1,1.7-3.8,3.8-3.8h72.8c2.1,0,3.8,1.7,3.8,3.8v5.5   C576,354.4,574.3,356.1,572.2,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.4,357.2h-67.3c-4.3,0-7.7-3.5-7.7-7.7c0-4.3,3.5-7.7,7.7-7.7h67.3c4.3,0,7.7,3.5,7.7,7.7   C577.1,353.7,573.7,357.2,569.4,357.2z M502.1,344c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5h67.3c3,0,5.5-2.5,5.5-5.5   c0-3-2.5-5.5-5.5-5.5H502.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M577.6,536.8c-0.2-11.4-4.8-20.9-14-27.8c-4.1-3.1-8.8-5.3-13.6-7.3c-5.3-2.3-11-3.7-16.1-6.5   c-3.3-1.8-5.9-3.7-7.3-6.7c0,0-0.2-0.9-0.4-1.4c0-0.3-0.1-0.8-0.1-1c0.2-1.8,0.9-3,2.3-4.3c7.9-7,21.8-2.7,30,1.4   c3.1,1.6,7.3,1.1,9.2-2.2c2-3.6,4.1-7.2,6.1-10.8c1.8-3.2,0.9-7.2-2.2-9.2c-7.4-4.6-16.4-7.6-25.5-8.4c0.1-0.4,0.1-0.8,0.1-1.3   l0.1-8.4c0.1-4.4-3.5-8.1-7.9-8.2l-1.3,0c-4.4-0.1-8.1,3.5-8.2,7.9l-0.1,8.4c0,0.9,0.1,1.7,0.4,2.5c-2,0.4-4,1-6,1.7   c-14.7,5.4-25.4,18.9-23.7,35c1.4,13.7,11.5,23.3,23.4,29c7.1,3.5,15.2,5.2,21.8,9.6c1.8,1.2,3.5,2.9,4.3,4.3c1.2,2,1.5,3,1.2,5.6   c-0.8,7.3-9.1,9.2-15.3,9.3c-9.3,0.1-17.5-3.3-24.8-8.9c-2.7-2.1-7.7-0.8-9.2,2.2c-2,4.1-4.1,8.3-6.1,12.4c-1.6,3.3-1,7.1,2.2,9.2   c8,5.2,17.3,8.8,26.8,10.3l-0.1,8.1c-0.1,4.4,3.5,8.1,7.9,8.2l1.3,0c4.4,0.1,8.1-3.5,8.2-7.9l0.1-8.2c2.3-0.3,4.6-0.8,6.9-1.4   c16.1-4.3,28.5-16.8,29.5-33.8c0-0.3,0-0.5,0-0.8C577.6,537.4,577.6,537.1,577.6,536.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M491.3,580.4c0.1,20.5-7.5,37.5-20.3,51.5c-12.7,13.6-49.8,12.4-49.8,12.4s-37.1,1.2-49.8-12.4    c-12.8-13.9-20.4-31-20.3-51.5c0.2-20.3,6.9-43.8,19.2-64.1c12.2-20,30.1-37,51-36.5c20.9-0.4,38.7,16.5,51,36.5    C484.4,536.7,491.1,560.2,491.3,580.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M472.1,516.3c-12.2-20-30.1-37-51-36.5c-1.5,0-2.9,0-4.3,0.2c12,7.1,22.3,19,30.3,32.2   c13.2,21.8,20.3,46.9,20.5,68.6c0.1,21.9-8.1,40.2-21.7,55.1c-3.4,3.6-8.4,6.3-14,8.2c12-0.7,30.7-3.3,39-12.2   c12.8-13.9,20.4-31,20.3-51.5C491.1,560.2,484.4,536.7,472.1,516.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M444.4,439.1c-2.2,1.9-5.2,2-8.4,1.1l-8.4,37.9h10.7l2.3-7.6l19.2-30.1C459.8,440.4,451.6,432.8,444.4,439.1z   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M421.2,431.8c0,0-16.1,13.6-23.2,7.3c-7.2-6.3-15.4,1.3-15.4,1.3l19.2,30.1l2.3,7.6h17.1h6.4l8.4-37.9   C428.9,438.3,421.2,431.8,421.2,431.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M442.2,485.7h-42c-1.2,0-2.2-1-2.2-2.2v-3.2c0-1.2,1-2.2,2.2-2.2h42c1.2,0,2.2,1,2.2,2.2v3.2   C444.4,484.7,443.4,485.7,442.2,485.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.6,486.4h-38.8c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5h38.8c2.5,0,4.5,2,4.5,4.5   C445.1,484.4,443.1,486.4,440.6,486.4z M401.8,478.8c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2h38.8c1.7,0,3.2-1.4,3.2-3.2   c0-1.7-1.4-3.2-3.2-3.2H401.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M442.2,478.1h-42c-1.2,0-2.2-1-2.2-2.2v-3.2c0-1.2,1-2.2,2.2-2.2h42c1.2,0,2.2,1,2.2,2.2v3.2   C444.4,477.1,443.4,478.1,442.2,478.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.6,478.8h-38.8c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5h38.8c2.5,0,4.5,2,4.5,4.5   C445.1,476.8,443.1,478.8,440.6,478.8z M401.8,471.1c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2h38.8c1.7,0,3.2-1.4,3.2-3.2   c0-1.7-1.4-3.2-3.2-3.2H401.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M445.3,582.5c-0.1-6.6-2.7-12.1-8.1-16c-2.4-1.8-5.1-3-7.8-4.2c-3.1-1.3-6.4-2.1-9.3-3.8   c-1.9-1.1-3.4-2.1-4.2-3.8c0,0-0.1-0.5-0.2-0.8c0-0.2-0.1-0.5,0-0.6c0.1-1,0.5-1.8,1.3-2.5c4.6-4,12.6-1.6,17.3,0.8   c1.8,0.9,4.2,0.6,5.3-1.3c1.2-2.1,2.3-4.2,3.5-6.3c1-1.8,0.5-4.2-1.3-5.3c-4.3-2.7-9.5-4.4-14.7-4.8c0-0.2,0.1-0.5,0.1-0.7l0.1-4.8   c0-2.5-2-4.7-4.6-4.7l-0.7,0c-2.5,0-4.7,2-4.7,4.6l-0.1,4.8c0,0.5,0.1,1,0.2,1.5c-1.2,0.3-2.3,0.6-3.5,1   c-8.5,3.1-14.7,10.9-13.7,20.2c0.8,7.9,6.7,13.4,13.5,16.7c4.1,2,8.8,3,12.6,5.6c1,0.7,2,1.7,2.5,2.5c0.7,1.2,0.9,1.7,0.7,3.3   c-0.5,4.2-5.3,5.3-8.8,5.4c-5.4,0.1-10.1-1.9-14.3-5.2c-1.6-1.2-4.5-0.4-5.3,1.3c-1.2,2.4-2.4,4.8-3.5,7.1   c-0.9,1.9-0.6,4.1,1.3,5.3c4.6,3,10,5.1,15.5,5.9l-0.1,4.7c0,2.5,2,4.7,4.6,4.7l0.7,0c2.5,0,4.7-2,4.7-4.6l0.1-4.7   c1.3-0.2,2.7-0.4,4-0.8c9.3-2.5,16.5-9.7,17-19.5c0-0.1,0-0.3,0-0.5C445.4,582.8,445.4,582.6,445.3,582.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/profit.8ea62bc0d09f654c3ec1b5d5fd7b87fe.svg";
export { ForwardRef as ReactComponent };